<div class="ps-gauge">
  <svg viewBox="0 0 220 140" class="ps-gauge-svg" aria-hidden="true">
    <path d="M 28 118 A 82 82 0 0 1 192 118" class="ps-gauge-track" pathLength="100"></path>
    <path d="M 28 118 A 82 82 0 0 1 192 118" class="ps-gauge-value" pathLength="100"
      [attr.stroke]="gaugeColor" [attr.stroke-dasharray]="dashArray"></path>
  </svg>
  <div class="ps-gauge-center">
    <div class="ps-gauge-value-text">{{ display }}</div>
    <div class="ps-gauge-caption">Overall Status</div>
    <!-- Status badges (Excellent / At Risk / Not Started) — re-enable later
    <span class="ps-badge" [ngClass]="badgeClass">{{ statusLabel }}</span>
    -->
  </div>
  <div class="ps-gauge-ends">
    <span>0%</span>
    <span>100%</span>
  </div>
</div>
